import type { HelpFile } from '../../types/help'
import { SpanDetailSheetTestIds } from '../../../testids/SpanDetailSheetTestIds'

export const spanDetailSheetHelp: HelpFile = {
  docPage: '/docs/admin/request-inspector',
  texts: {
    [SpanDetailSheetTestIds.spanDetailSheet]: 'Detail panel for one span in the request trace. Switch tabs to inspect attributes, HTTP info, SQL statements, or the captured error.',
    [SpanDetailSheetTestIds.tabHttp]: 'HTTP method, status code, URL, and request/response sizes captured for this span.',
    [SpanDetailSheetTestIds.tabSql]: 'SQL statement, parameters, and execution duration recorded inside this span.',
    [SpanDetailSheetTestIds.tabError]: 'Error or exception thrown during this span — type, message, and stack trace.',
    [SpanDetailSheetTestIds.attributesJson]: 'Raw OpenTelemetry attribute bag attached to the span. Useful for spans that the UI does not specialise.',
    [SpanDetailSheetTestIds.btnViewErrorLog]: 'Open the matching error log entry to see the full request context and other occurrences.',
    [SpanDetailSheetTestIds.linkViewErrorLog]: 'Jump to the matching error log entry for this span.',
  },
}
